import { FunctionComponent } from 'react';
import { Container } from 'components/elements';
import { StyledPage } from './Page.styled';
import { MainContainerStyle } from 'styles/InlineStyles';

export const Page: FunctionComponent = props => {
  const { children } = props;

  return (
    <StyledPage>
      <Container style={MainContainerStyle}>{children}</Container>
    </StyledPage>
  );
};
